export default __webpack_public_path__ + "static/media/navi3.0b41a6da.gif";